<template>
  <div class="contact-form-container">
    <transition name="fade">
      <div class="toast" v-if="showToast">
        <p>{{ toastMessage }}</p>
      </div>
    </transition>

    <h2>NOUS CONTACTER</h2>

    <!-- Message de bienvenue -->
    <p v-if="firstname && lastname" class="welcome-message">
      Bonjour {{ firstname }} {{ lastname }}, vous êtes connecté. Vous pouvez nous envoyer un message via le formulaire ci-dessous.
    </p>

    <form @submit.prevent="submitForm" style="margin-bottom: 50px;">
      <div class="input-group oc-field">
        <label v-if="isNative" class="oc-field__label" for="message">Votre message</label>
        <textarea
          v-model="message"
          id="message"
          name="message"
          placeholder="Message"
          class="oc-field__control"
          required
        ></textarea>
      </div>
      <div class="checkbox-group">
        <input type="checkbox" id="consent" name="consent" required />
        <label for="consent">
          Je comprends que, lors du transfert des données via ce formulaire de contact et après avoir cliqué sur le bouton "Envoyer", mes données personnelles sont transmises au responsable du site uniquement pour permettre à ce dernier de me répondre.
        </label>
      </div>
      <div class="captcha-group">
        <!-- Widget reCAPTCHA. -->
        <div class="g-recaptcha" data-sitekey="votre-clé-site"></div>
      </div>
      <button type="submit" class="submit-button oc-btn oc-btn--primary oc-btn--block">ENVOYER</button>
    </form>

    <!-- Natif : joindre l'équipe en un geste (compose l'appel / ouvre le mail). -->
    <section v-if="isNative" class="oc-contact-direct">
      <h3 class="oc-contact-direct__title">Nous joindre directement</h3>

      <a class="oc-contact-tile" href="tel:+33686800567">
        <span class="oc-contact-tile__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
            <path d="M6.6 3.5h3l1.4 3.6-2 1.4a12 12 0 0 0 6.5 6.5l1.4-2 3.6 1.4v3a2 2 0 0 1-2.2 2A16.5 16.5 0 0 1 4.6 5.7a2 2 0 0 1 2-2.2Z" />
          </svg>
        </span>
        <span class="oc-contact-tile__text">
          <span class="oc-contact-tile__label">Téléphone</span>
          <span class="oc-contact-tile__value">+33 (0)6 86 80 05 67</span>
        </span>
        <svg class="oc-contact-tile__chev" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="m9.5 5.5 6.5 6.5-6.5 6.5" />
        </svg>
      </a>

      <a class="oc-contact-tile" href="mailto:contact@ouicsport.fr">
        <span class="oc-contact-tile__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="5" width="18" height="14" rx="2.5" />
            <path d="m3.8 7 8.2 6 8.2-6" />
          </svg>
        </span>
        <span class="oc-contact-tile__text">
          <span class="oc-contact-tile__label">E-mail</span>
          <span class="oc-contact-tile__value">contact@ouicsport.fr</span>
        </span>
        <svg class="oc-contact-tile__chev" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="m9.5 5.5 6.5 6.5-6.5 6.5" />
        </svg>
      </a>
    </section>
  </div>
</template>

<script>
import axios from 'axios';
import { useStore } from 'vuex';
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { isNative } from '@/api/base';

export default {
  setup() {
    const store = useStore();
    const router = useRouter();

    const userId = ref(store.state.auth?.user?.data?.id || null);
    const firstname = ref(store.state.auth?.user?.data?.firstname || '');
    const lastname = ref(store.state.auth?.user?.data?.lastname || '');
    const message = ref('');

    const showToast = ref(false);
    const toastMessage = ref('');

    const showToastMessage = (msg) => {
      toastMessage.value = msg;
      showToast.value = true;
      setTimeout(() => {
        showToast.value = false;
        toastMessage.value = '';
      }, 4000);
    };

    onMounted(() => {
      if (!userId.value) {
        router.push('/login');
      }
    });

    const submitForm = async () => {
      if (!userId.value) {
        showToastMessage('Vous devez être connecté pour envoyer un message.');
        return;
      }


      const formData = new FormData();
        formData.append('userId', userId.value);
        formData.append('message', message.value);

      try {
        const response = await axios.post('/api/offer/send-message', formData);
        if (response.status === 200) {
          showToastMessage('✅ Votre message a bien été envoyé.');
          message.value = '';
        }
      } catch (error) {
        console.error('Erreur lors de l\'envoi du message :', error);
        showToastMessage('❌ Une erreur est survenue lors de l\'envoi de votre message.');
      }
    };

    return {
      userId,
      firstname,
      lastname,
      message,
      submitForm,
      showToast,
      toastMessage,
      isNative,
    };
  },
};
</script>
<style scoped>
.contact-form-container {
  height: 60vh;
  position: relative;
}

.welcome-message {
  margin-bottom: 20px;
}

.toast {
  position: fixed;
  top: 20px;
  right: 20px;
  background-color: #2c3e50;
  color: #fff;
  padding: 12px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.2);
  z-index: 9999;
  font-weight: 500;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>

<style>
/* =========================================================================
   ContactComponent — application mobile (iOS / Android)
   Toutes les règles sont préfixées body.is-native : le site web est inchangé.

   Intention : un écran « Contact » d'application. Un titre unique en Gagalin,
   le formulaire posé dans une carte blanche sur le fond chaud, puis deux
   tuiles tactiles (tel: / mailto:) qui ouvrent directement les applications
   système — c'est ce qu'un utilisateur mobile cherche en premier.
   ========================================================================= */

body.is-native .contact-form-container {
  width: 100%;
  height: auto;
  min-height: 0;
  box-sizing: border-box;
  padding: var(--oc-sp-6) var(--oc-sp-4) var(--oc-sp-8);
  background: var(--oc-bg);
  text-align: left;
}

body.is-native .contact-form-container h2 {
  margin: 0 0 var(--oc-sp-2);
  font-family: var(--oc-font-display);
  font-size: var(--oc-text-display);
  font-weight: 400;
  line-height: 1.15;
  letter-spacing: 0.3px;
  color: var(--oc-ink);
  text-align: left;
  text-transform: uppercase;
}

body.is-native .contact-form-container .welcome-message {
  margin: 0 0 var(--oc-sp-5);
  font-size: var(--oc-text-base);
  line-height: 1.5;
  color: var(--oc-ink-2);
  text-align: left;
}

/* --- Le formulaire : une seule carte, pas une suite de blocs flottants --- */

body.is-native .contact-form-container form {
  display: block;
  width: 100%;
  box-sizing: border-box;
  /* neutralise le style en ligne margin-bottom:50px du gabarit web */
  margin: 0 0 var(--oc-sp-8) !important;
  padding: var(--oc-sp-4);
  background: var(--oc-surface);
  border-radius: var(--oc-r-lg);
  box-shadow: var(--oc-e1);
}

body.is-native .contact-form-container .input-group.oc-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  margin: 0 0 var(--oc-sp-4);
}

body.is-native .contact-form-container .oc-field__label {
  font-size: var(--oc-text-sm);
  font-weight: 700;
  color: var(--oc-ink-2);
}

body.is-native .contact-form-container textarea.oc-field__control {
  width: 100%;
  height: auto;
  min-height: 132px;
  box-sizing: border-box;
  margin: 0;
  padding: var(--oc-sp-3) var(--oc-sp-4);
  font-family: var(--oc-font-text);
  /* 16px minimum : en dessous, iOS zoome à la mise au point. */
  font-size: var(--oc-text-base);
  line-height: 1.5;
  color: var(--oc-ink);
  background: var(--oc-surface);
  border: 1px solid var(--oc-line-2);
  border-radius: var(--oc-r-md);
  -webkit-appearance: none;
  appearance: none;
  outline: none;
  resize: none;
  transition: border-color var(--oc-fast) var(--oc-ease),
              box-shadow var(--oc-fast) var(--oc-ease);
}

body.is-native .contact-form-container textarea.oc-field__control::placeholder {
  color: var(--oc-ink-3);
}

body.is-native .contact-form-container textarea.oc-field__control:focus {
  border-color: var(--oc-brand);
  box-shadow: 0 0 0 3px var(--oc-brand-100);
}

/* Consentement : un pavé discret, texte lisible (AA sur --oc-surface-2). */
body.is-native .contact-form-container .checkbox-group {
  display: flex;
  align-items: flex-start;
  gap: var(--oc-sp-3);
  margin: 0 0 var(--oc-sp-4);
  padding: var(--oc-sp-3);
  background: var(--oc-surface-2);
  border-radius: var(--oc-r-md);
  text-align: left;
}

body.is-native .contact-form-container .checkbox-group input[type="checkbox"] {
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
  margin: 1px 0 0;
  accent-color: var(--oc-brand);
}

body.is-native .contact-form-container .checkbox-group label {
  font-size: var(--oc-text-sm);
  line-height: 1.45;
  color: var(--oc-ink-2);
}

/* Le widget reCAPTCHA n'est pas chargé dans l'application : le bloc vide ne
   laissait qu'un trou dans la carte. */
body.is-native .contact-form-container .captcha-group {
  display: none;
}

body.is-native .contact-form-container .submit-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: var(--oc-tap);
  height: auto;
  margin: 0;
  padding: 0 var(--oc-sp-5);
  font-family: var(--oc-font-text);
  font-size: var(--oc-text-base);
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--oc-brand-ink);
  background: var(--oc-brand);
  border: 0;
  border-radius: var(--oc-r-full);
  box-shadow: var(--oc-e1);
  cursor: pointer;
  transition: transform var(--oc-fast) var(--oc-ease),
              background var(--oc-fast) var(--oc-ease);
}

body.is-native .contact-form-container .submit-button:active {
  background: var(--oc-brand-600);
  transform: scale(0.98);
}

/* --- Coordonnées : deux tuiles tactiles (>= 44px) --- */

body.is-native .oc-contact-direct {
  margin: 0;
}

body.is-native .oc-contact-direct__title {
  margin: 0 0 var(--oc-sp-3);
  font-family: var(--oc-font-display);
  font-size: var(--oc-text-title);
  font-weight: 400;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: var(--oc-ink);
  text-align: left;
}

body.is-native .oc-contact-tile {
  display: flex;
  align-items: center;
  gap: var(--oc-sp-3);
  min-height: 64px;
  margin-bottom: var(--oc-sp-3);
  padding: var(--oc-sp-2) var(--oc-sp-3);
  color: var(--oc-ink);
  background: var(--oc-surface);
  border-radius: var(--oc-r-lg);
  box-shadow: var(--oc-e1);
  text-decoration: none;
  transition: transform var(--oc-fast) var(--oc-ease),
              background var(--oc-fast) var(--oc-ease);
}

body.is-native .oc-contact-tile:last-child {
  margin-bottom: 0;
}

body.is-native .oc-contact-tile:active {
  background: var(--oc-brand-50);
  transform: scale(0.99);
}

body.is-native .oc-contact-tile__icon {
  display: flex;
  flex: 0 0 var(--oc-tap);
  align-items: center;
  justify-content: center;
  width: var(--oc-tap);
  height: var(--oc-tap);
  color: var(--oc-brand);
  background: var(--oc-brand-50);
  border-radius: var(--oc-r-full);
}

body.is-native .oc-contact-tile__text {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  gap: 1px;
}

body.is-native .oc-contact-tile__label {
  font-size: var(--oc-text-xs);
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--oc-ink-3);
}

body.is-native .oc-contact-tile__value {
  font-size: var(--oc-text-base);
  font-weight: 600;
  color: var(--oc-ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

body.is-native .oc-contact-tile__chev {
  flex: 0 0 auto;
  color: var(--oc-ink-3);
}

/* --- Confirmation d'envoi : au pouce, au-dessus de la barre d'onglets --- */

body.is-native .contact-form-container .toast {
  position: fixed;
  top: auto;
  left: calc(var(--oc-sp-4) + var(--oc-safe-left));
  right: calc(var(--oc-sp-4) + var(--oc-safe-right));
  bottom: calc(var(--oc-tabbar-h) + var(--oc-safe-bottom) + var(--oc-sp-4));
  z-index: 1200;
  padding: var(--oc-sp-3) var(--oc-sp-4);
  font-family: var(--oc-font-text);
  font-size: var(--oc-text-sm);
  font-weight: 600;
  color: #FFFFFF;
  background: rgba(26, 22, 20, 0.94);
  border-radius: var(--oc-r-md);
  box-shadow: var(--oc-e3);
  text-align: center;
}

body.is-native .contact-form-container .toast p {
  margin: 0;
}
</style>



